import { render } from "./AboutKujibiki.vue?vue&type=template&id=03af4c98&scoped=true"
const script = {}

import "./AboutKujibiki.vue?vue&type=style&index=0&id=03af4c98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03af4c98"]])

export default __exports__